// src/pages/Servicos.tsx
import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import ServicosHero from '../components/Servicos/ServicosHero';
import ServicosGrid from '../components/Servicos/ServicosGrid';
import ServicosFAQ from '../components/Servicos/ServicosFAQ';
import ServicosCTA from '../components/Servicos/ServicosCTA';
import { SERVICOS } from '../components/Servicos/services.data';
import { ServicoKey } from '../components/Servicos/services.types';

const pathToKey = (pathname: string): ServicoKey | null => {
  // suas rotas no App.tsx
  if (pathname === '/servicos/diploma') return 'diploma';
  if (pathname === '/servicos/cosmetologo') return 'cosmetologo';
  if (pathname === '/servicos/licenca') return 'licenca';
  if (pathname === '/servicos/site') return 'site';
  return null;
};

const keyToPath: Record<ServicoKey, string> = {
  diploma: '/servicos/diploma',
  cosmetologo: '/servicos/cosmetologo',
  licenca: '/servicos/licenca',
  site: '/servicos/site',
};

const Servicos: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const selectedKey = useMemo<ServicoKey | null>(() => {
    return pathToKey(location.pathname);
  }, [location.pathname]);

  const handleContratar = (key: ServicoKey) => {
    navigate(keyToPath[key]); // ✅ sempre rota válida do seu header
  };

  return (
    <div className="min-h-screen bg-color-background">
      <ServicosHero />

      {/* Se quiser, depois a gente passa selectedKey para destacar no grid */}
      <ServicosGrid servicos={SERVICOS} onClickContratar={handleContratar} />

      <ServicosFAQ />
      <ServicosCTA />
    </div>
  );
};

export default Servicos;
